import { useEffect, useState } from "react";

export default function Timer({ setTimeOut, questionNumber, isAnswerSelected }) {
  const [timer, setTimer] = useState(30);

  useEffect(() => {
    if (timer === 0) return setTimeOut(true);
    if (isAnswerSelected) return; // Stop timer when answer is selected
    
    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timer, setTimeOut, isAnswerSelected]);

  useEffect(() => {
    setTimer(30);
  }, [questionNumber]);
  
  return timer;
}
